import type { ActionContext } from '../types';
import type { AbilityModifier, ConditionFn, OverrideContext } from './types';
import { CONDITIONS } from './Conditions';

/** Evaluate once per cast. Never write into the builder's shared metadata. */
export function withCastOverrides(
  ctx: ActionContext,
  conditionals: ReadonlyArray<{ condition: ConditionFn; modifier: AbilityModifier }>,
): ActionContext {
  const overrides: OverrideContext = {
    damageMultiplier: 1, extraCasts: 0, cooldownReduction: 0,
    manaRefundPercent: 0, extraProjectiles: 0,
  };
  for (const entry of conditionals) {
    const condition = typeof entry.condition === 'string' ? CONDITIONS[entry.condition] : entry.condition;
    if (condition(ctx)) entry.modifier(overrides);
  }
  return { ...ctx, castOverrides: Object.freeze(overrides) };
}

/** Local behavior damage only; server damage is independently calculated. */
export function applyCastDamage(ctx: ActionContext, damage: number): number {
  const multiplier = ctx.castOverrides?.damageMultiplier ?? 1;
  return multiplier === 1 ? damage : Math.floor(damage * multiplier);
}
